import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "direction", "transitionKey"];
import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import { TransitionContainer } from './styles';
var SlideTransition = function SlideTransition(_ref) {
  var children = _ref.children,
    direction = _ref.direction,
    transitionKey = _ref.transitionKey,
    other = _objectWithoutProperties(_ref, _excluded);
  var transitionClasses = {
    enter: "slide-enter-".concat(direction),
    enterActive: 'slide-enter-active',
    exit: 'slide-exit',
    exitActive: "slide-exit-".concat(direction)
  };
  return /*#__PURE__*/React.createElement(TransitionContainer, _extends({
    childFactory: function childFactory(element) {
      return /*#__PURE__*/React.cloneElement(element, {
        classNames: transitionClasses
      });
    }
  }, other), /*#__PURE__*/React.createElement(CSSTransition, {
    mountOnEnter: true,
    unmountOnExit: true,
    key: "".concat(transitionKey).concat(direction),
    timeout: 350,
    classNames: transitionClasses
  }, children));
};
process.env.NODE_ENV !== "production" ? SlideTransition.propTypes = {
  direction: PropTypes.oneOf(['left', 'right']).isRequired
} : void 0;
export default SlideTransition;